import { render, staticRenderFns } from "./UseGasAnalysis.vue?vue&type=template&id=536115e0&scoped=true&"
import script from "./UseGasAnalysis.vue?vue&type=script&lang=js&"
export * from "./UseGasAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./UseGasAnalysis.vue?vue&type=style&index=0&id=536115e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536115e0",
  null
  
)

export default component.exports